import { FAVORITES_GET_SUCCESS, FAVORITES_GET_FAILURE } from '../actions/types';
import favoritesConfig from '../configs';

/** @type {{config: object, placements: array.<object>}} */
const initialState = {
  config: favoritesConfig,
  merchants: [],
  isLoading: false,
  isLoaded: false,
};

const handleResponse = (response) => (
  response.map(({ merchant }) => (merchant))
);

/**
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
const favorites = (state = initialState, action) => {
  switch (action.type) {
    case FAVORITES_GET_SUCCESS: {
      const merchants = handleResponse(action.payload.response);
      return {
        ...state,
        merchants,
        isLoading: false,
        isLoaded: true,
      };
    }
    case FAVORITES_GET_FAILURE: {
      return {
        ...state,
        merchants: [],
        isLoading: false,
        isLoaded: true,
      }; // we'd have to decide what to do with error state
    }
    default: {
      const { options = {} } = action;
      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === FAVORITES_GET_SUCCESS) {
        return { ...state, isLoading: true };
      }

      return state;
    }
  }
};

export default favorites;
